import React, { Component } from 'react';
import {
    Col, Row, Form, Button
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SendingEmail } from '../../../../redux/Action/Auth/ForgetAction'
import RenderField from '../../../../components/Fields/fields'
import String from '../../../../assets/Locales/teacher_locales.js';
import { Inputs } from './inputSettings'
import validate from './validation';
import '../forgetpassword.css'

class Login extends Component {
    onSubmit = (values) => {
        console.log("values",values)
        this.props.SendingEmail(values, localStorage.getItem('Language'))
    }
    render() {
        let lang = localStorage.getItem("Language");
        // console.log("lang", lang)
        if (lang) {
            // console.log("lang in if", lang)
            String.setLanguage(localStorage.getItem("Language"));
        } else {
            // console.log("lang in else", lang)
            lang = "ar"
            String.setLanguage("ar");
        }
        const { handleSubmit, submitting } = this.props
        return (

            <Col lg="4" md="6" style={{ margin: 'auto', marginTop: '8%' }}>
                <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    {
                        Inputs.map((row, index) => {
                            return (
                                <Row>
                                    {
                                        row.map((element, index) => {
                                            return (
                                                <Field
                                                    lang={lang}
                                                    type={element.type}
                                                    name={element.name}
                                                    component={RenderField}
                                                    label={lang === "ar" ? element.label.ar : element.label.en}
                                                    placeholder={element.placeholder}
                                                    options={element.options}
                                                    optionTitle={element.optionTitle ? (this.props.lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                // title={lang === "ar" ? element.title.ar : element.title.en}
                                                />
                                            )
                                        })

                                    }
                                    <Col md="6" style={{ margin: '10% auto 5%' }} >
                                        <Button type="submit" className="btn submitBtn" disabled={submitting}> {lang === 'ar' ? 'ارسال' : 'Send'}  </Button>
                                    </Col>
                                </Row>
                            )
                        })
                    }
                </Form>
            </Col>
        )
    }
}
const mapStateToProps = state => {
    return {
        lang: state.lang.lang,
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        SendingEmail
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(Login));